let pricingCV2 = document.querySelector('.js-pricing-v2')
let prods = window.product || []

let pro_options = window.options || []
let $priceDom = document.getElementById('sp_price1')
let $cPriceDom = document.getElementById('sp_price2')
let currentSelections = {} // 唯一声明：避免重复
const PRICE_REGEX = /\d+(?:[.,]\d+)*/
const OFF_REGEX = /(\d+)(?=(?:<[^>]+>|\s)*%)/g

// 提前定义核心函数changePrice（解决调用前置问题）
function changePrice() {
  const $numDom = document.querySelector('.js-quantity-value')
  // 全量判空：任一核心变量不存在，直接返回
  console.log($priceDom, $cPriceDom, $numDom, 'currentText')
  if (!pricingCV2 || !prods.length || !$priceDom || !$cPriceDom || !$numDom)
    return

  // 获取当前选中变体
  const curVariant = getCur()
  console.log(curVariant, 'currentText')
  if (!curVariant || !curVariant.price) return

  // 获取数量：简化逻辑+防非数字
  const numText = $numDom.textContent?.trim() || '1'
  const num =
    !isNaN(Number(numText)) && Number(numText) > 0 ? Number(numText) : 1

  // 解析价格格式（保留原逻辑）
  const currentText = $priceDom.textContent.trim()
  // console.log(currentText,"currentText")
  const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/)
  const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g
  const decimalSeparator = decimalMatch ? decimalMatch[1] : '.'
  const decimalLength = decimalMatch ? decimalMatch[2].length : 0

  // 价格格式化函数
  const formatValue = cents => {
    let val = ((cents * num) / 100000).toFixed(decimalLength)
    return decimalSeparator === ',' ? val.replace('.', ',') : val
  }

  // 计算价格/折扣
  const price = formatValue(curVariant.price)
  const compare = curVariant.compare_at_price
    ? formatValue(curVariant.compare_at_price)
    : price
  let offPercent = 0
  if (
    curVariant.compare_at_price &&
    curVariant.compare_at_price > curVariant.price
  ) {
    offPercent =
      100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100)
  }

  // jQuery对象更新HTML（增加判空）
  // 原生JS版 updateHTML：替换指定元素的文本（正则匹配），避免重复更新DOM
  const updateHTML = (el, regex, value) => {
    // 严格判空：确保el是有效原生DOM元素（排除null/undefined/非DOM对象）
    if (!el || !(el instanceof HTMLElement)) return

    // 1. 获取元素纯文本并去空格（和原jQuery逻辑一致）
    const text = el.textContent.trim()
    // 2. 正则替换目标内容，得到新的HTML
    const newHtml = text.replace(regex, value)
    // 3. 对比新旧内容，不同时才更新（避免重复操作DOM，提升性能）
    if (el.innerHTML !== newHtml) {
      el.innerHTML = newHtml
    }
  }

  // 更新价格/折扣
  updateHTML($priceDom, PRICE_REGEX, price)
  updateHTML($cPriceDom, PRICE_REGEX, compare)
  updateHTML(pricingCV2?.querySelector('.font-off'), offRegex, offPercent)
  // 折扣元素判空
  // const offEl = pricingCV2?.querySelector('.font-off')
  // if (offEl) offEl.textContent = offPercent
}

function getCur() {
  if (!prods.length || Object.keys(currentSelections).length === 0) return null
  // 按索引排序选中值，生成匹配条件
  const selectedVals = Object.keys(currentSelections)
    .sort((a, b) => Number(a) - Number(b))
    .map(k => currentSelections[k])
  // 动态匹配option1/option2/option3...（兼容任意分组数）

  return prods.find(item => {
    return selectedVals.every((val, idx) => {
      const optionKey = `option${idx + 1}`
      return item[optionKey] === pro_options[idx]?.values[val]
    })
  })
}
pricingCV2
  ?.querySelector('.sp_buy_now')
  ?.addEventListener('click', function () {
    let num =
      document.querySelector('.js-quantity-value')?.textContent?.trim() || 1
    let id = getCur().id

    window.location.href = '/cart/' + id + ':' + num
  })
// Helper to get current page scale (Zoom or Transform)
function getPageScale() {
  let scale = 1
  if (
    document.body.style.zoom &&
    document.body.style.zoom !== '1' &&
    document.body.style.zoom !== ''
  ) {
    scale = parseFloat(document.body.style.zoom)
  } else if (
    document.body.style.transform &&
    document.body.style.transform.includes('scale')
  ) {
    const match = document.body.style.transform.match(/scale\(([^)]+)\)/)
    if (match && match[1]) scale = parseFloat(match[1])
  }
  return scale
}

// Mock getCur for local preview
if (typeof getCur === 'undefined') {
  window.getCur = function () {
    return { id: 'mock-id' }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // Helper to get current page scale (Zoom or Transform)
  function getPageScale() {
    let scale = 1
    if (
      document.body.style.zoom &&
      document.body.style.zoom !== '1' &&
      document.body.style.zoom !== ''
    ) {
      scale = parseFloat(document.body.style.zoom)
    } else if (
      document.body.style.transform &&
      document.body.style.transform.includes('scale')
    ) {
      const match = document.body.style.transform.match(/scale\(([^)]+)\)/)
      if (match && match[1]) scale = parseFloat(match[1])
    }
    return scale
  }

  // --- ANIMATION FIX: Native Observer ---
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  }

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible')
        observer.unobserve(entry.target)
      }
    })
  }, observerOptions)

  const elements = document.querySelectorAll('.reveal-on-scroll')
  if ('IntersectionObserver' in window) {
    elements.forEach(section => {
      observer.observe(section)
    })
  } else {
    elements.forEach(section => {
      section.classList.add('is-visible')
    })
  }

  // --- NAVBAR SCROLL LOGIC ---
  const header = document.querySelector('header[data-navbar-style]')
  const wrapper = document.querySelector('[data-navbar-wrapper]')
  const nav = document.querySelector('[data-navbar-nav]')

  if (header && wrapper && nav) {
    const isFloatingStyle =
      header.getAttribute('data-navbar-style') === 'floating'

    function updateNavbar() {
      const isScrolled = window.scrollY > 20

      if (isFloatingStyle) {
        if (isScrolled) {
          // Snapped state
          wrapper.className =
            'md:absolute md:w-full md:left-0 md:px-0 md:pt-0 transition-all duration-300'
          nav.className =
            'px-6 flex justify-between items-center relative transition-all duration-300 border-b border-gray-100 shadow-sm'
        } else {
          // Floating state
          wrapper.className =
            'md:absolute md:w-full md:left-0 md:px-6 md:pt-4 transition-all duration-300'
          nav.className =
            'px-6 flex justify-between items-center relative transition-all duration-300 border-b border-gray-100 md:border-none md:max-w-6xl md:mx-auto md:rounded-full md:shadow-lg'
        }
      } else {
        if (isScrolled) {
          nav.classList.add('shadow-sm')
        } else {
          nav.classList.remove('shadow-sm')
        }
      }
    }

    window.addEventListener('scroll', updateNavbar)
    updateNavbar() // Initial check
  }

  // --- ANCHOR SCROLL FIX: Enhanced Logic ---
  var links = document.querySelectorAll('a[href^="#"]')
  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      // 1. Ensure default event is prevented
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault() // Prevent default anchor jump
        event.stopPropagation() // Stop event bubbling
      }

      // 2. Get target element
      const href = link.getAttribute('href')
      if (!href || href === '#') return
      const targetId = href.substring(1)
      const targetElement = document.getElementById(targetId)

      if (!targetElement) {
        return
      }

      // 3. Custom Scroll Logic
      const rect = targetElement.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      // 适配移动端：屏幕较窄时减小偏移量，解决 iOS/移动端定位偏下的问题
      const headerOffset = window.innerWidth < 1080 ? 60 : 100
      const targetPosition = rect.top + scrollTop - headerOffset

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      })
    })
  })

  // Add to Cart Animation - Universal Fix
  document.querySelectorAll('.add_cart_btn, .js-add-to-cart').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault()

      // 1. 基础元素获取
      const cartIcon =
        document.getElementById('navbar-cart-icon') ||
        document.querySelector('.cart-icon')
      const cartCount =
        document.getElementById('navbar-cart-count') ||
        document.querySelector('.cart-count-bubble')
      const section = btn.closest('section')
      const isPricingV2 = section?.classList.contains('js-pricing-v2')
      const img = section
        ? section.querySelector('.js-main-image') ||
          section.querySelector('img')
        : null
      const startEl = img && !isPricingV2 ? img : btn
      const $numDom = document.querySelector('.js-quantity-value')

      // 2. 数据准备
      const data = {
        id: typeof getCur !== 'undefined' ? getCur().id : 'mock-id',
        quantity:
          $numDom && $numDom.textContent ? $numDom.textContent.trim() : '1',
      }

      // ✅ 核心工具函数：全兼容获取购物车坐标（PC/移动端分开处理）
      const getCartIconPosition = () => {
        if (!cartIcon) return { left: 0, top: 0 }

        // 基础环境判断
        const viewportWidth = window.innerWidth
        const isMobile = viewportWidth < 768 // 移动端断点，可根据你的页面调整
        const dpr = window.devicePixelRatio || 1

        // 方案1：优先使用 getBoundingClientRect()（99%场景生效，移动端优先）
        try {
          const rect = cartIcon.getBoundingClientRect()
          let left = rect.left
          let top = rect.top

          // ✅ 仅PC端做滚动条补偿，移动端完全禁用
          if (!isMobile) {
            const scrollbarWidth =
              window.innerWidth - document.documentElement.clientWidth
            left += scrollbarWidth > 0 ? scrollbarWidth : 0
          }

          // ✅ 仅PC端高DPR屏幕做校准，移动端完全禁用dpr除法
          if (!isMobile && dpr > 1) {
            left = left / dpr
            top = top / dpr
          }

          // 取整消除小数差异
          left = Math.round(left)
          top = Math.round(top)

          // 坐标合理性校验：移动端left必须大于视口宽度的50%（购物车在右侧）
          const isValid = isMobile
            ? left > viewportWidth * 0.5 &&
              left <= viewportWidth &&
              top >= 0 &&
              top <= 100
            : left >= 0 &&
              left <= viewportWidth &&
              top >= 0 &&
              top <= window.innerHeight

          if (isValid) {
            console.log('✅ 生效方案：getBoundingClientRect', {
              left,
              top,
              isMobile,
            })
            return { left, top }
          }
        } catch (e) {
          console.warn('getBoundingClientRect() 失败，尝试备选方案', e)
        }

        // 方案2：备选方案（仅PC端用，移动端废弃递归offset方案）
        if (!isMobile) {
          try {
            let left = 0
            let top = 0
            let currentEl = cartIcon

            while (currentEl && currentEl !== document.body) {
              const elStyle = window.getComputedStyle(currentEl)
              if (elStyle.position !== 'fixed') {
                left += currentEl.offsetLeft
                top += currentEl.offsetTop
              }
              currentEl = currentEl.offsetParent
            }

            // 转换为视口坐标
            left -= window.scrollX
            top -= window.scrollY
            const finalLeft = Math.round(left)
            const finalTop = Math.round(top)

            console.log('✅ 生效方案：offset递归', {
              left: finalLeft,
              top: finalTop,
            })
            return { left: finalLeft, top: finalTop }
          } catch (e) {
            console.warn('offset递归计算失败，使用兜底方案', e)
          }
        }

        // 方案3：兜底方案（移动端优先用这个百分比，适配所有手机屏幕）
        const viewportHeight = window.innerHeight
        // 👉 这里替换成你页面真实的百分比：移动端购物车在右侧90%位置，顶部5%位置
        const cartPercentX = isMobile ? 90 : 92
        const cartPercentY = isMobile ? 5 : 5

        const finalLeft = Math.round((viewportWidth * cartPercentX) / 100)
        const finalTop = Math.round((viewportHeight * cartPercentY) / 100)
        console.log('✅ 生效方案：兜底百分比', {
          left: finalLeft,
          top: finalTop,
          isMobile,
        })
        return { left: finalLeft, top: finalTop }
      }

      // 4. 创建飞行动画元素
      const fly = document.createElement('div')
      const size = 50
      const startRect = startEl.getBoundingClientRect()
      const isMobile = window.innerWidth < 768

      // 起始位置设置（全兼容）
      fly.style.position = 'fixed'
      fly.style.zIndex = '2147483647'
      fly.style.display = 'block'
      fly.style.width = size + 'px'
      fly.style.height = size + 'px'
      fly.style.borderRadius = '50%'
      fly.style.backgroundImage = img ? 'url(' + img.src + ')' : 'none'
      fly.style.backgroundColor = img ? 'transparent' : '#d23420'
      fly.style.backgroundSize = 'cover'
      fly.style.backgroundPosition = 'center'
      fly.style.transition = 'all 1s cubic-bezier(0.19, 1, 0.22, 1)'
      fly.style.pointerEvents = 'none'
      fly.style.boxShadow = '0 10px 25px -5px rgba(0,0,0,0.3)'

      // 起始位置适配移动端
      const startLeft = startRect.left - size / 2
      const startTop = startRect.top - size / 2
      fly.style.left = startLeft + 'px'
      fly.style.top = startTop + 'px'

      // 挂载到html根节点，避开body的transform/zoom干扰
      document.documentElement.appendChild(fly)
      void fly.offsetWidth // 强制触发重绘

      // 5. 设置终点位置（核心修复）
      if (cartIcon) {
        const cartPos = getCartIconPosition()
        const endSize = 20
        // ✅ 动态获取购物车真实宽高，不再写死24px
        const cartWidth = cartIcon.offsetWidth || 24
        const cartHeight = cartIcon.offsetHeight || 24

        // 精准对齐购物车图标中心
        const endLeft = cartPos.left + cartWidth / 2 - endSize / 2
        const endTop = cartPos.top + cartHeight / 2 - endSize / 2

        // 调试日志，方便你排查
        console.log('🔍 最终落点详情', {
          cartPos,
          cartWidth,
          cartHeight,
          endLeft,
          endTop,
          isMobile,
        })

        // 赋值动画终点
        fly.style.left = endLeft + 'px'
        fly.style.top = endTop + 'px'
        fly.style.width = endSize + 'px'
        fly.style.height = endSize + 'px'
        fly.style.opacity = '0.2'
      } else {
        // 无购物车图标时的兜底动画
        fly.style.top = startTop - 100 + 'px'
        fly.style.opacity = '0'
      }

      // 6. 加购请求逻辑
      if (typeof $ !== 'undefined' && $.ajax) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          success: function () {
            if (window.Shopify && window.Shopify.routes) {
              $.getJSON(
                window.Shopify.routes.root + 'cart.js',
                function (result) {
                  // 更新购物车数量
                  if (cartCount) {
                    cartCount.textContent = parseInt(result.item_count || '0')
                  } else if (cartIcon) {
                    let badge = document.getElementById('navbar-cart-count')
                    if (!badge) {
                      badge = document.createElement('span')
                      badge.id = 'navbar-cart-count'
                      badge.className =
                        'absolute -top-1.5 -right-1.5 bg-red-600 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full font-bold shadow-sm ring-1 ring-white'
                      badge.textContent = '0'
                      cartIcon.appendChild(badge)
                    }
                    badge.textContent = parseInt(result.item_count || '0')
                  }
                }
              )
            }
          },
          complete: function () {
            // 无论请求成功失败，1s后都移除动画元素
            setTimeout(() => {
              if (fly.parentNode) fly.parentNode.removeChild(fly)
            }, 1000)
          },
          dataType: 'json',
        })
      } else {
        // Fallback for local preview (no jQuery)
        console.log('jQuery not found, simulating cart add')
        setTimeout(() => {
          if (fly.parentNode) fly.parentNode.removeChild(fly)
          if (cartCount) {
            cartCount.textContent = parseInt(cartCount.textContent || '0') + 1
          }
        }, 1000)
      }
    })
  })

  // Universal Stock Progress Bar Fix
  // Force width and background color via JS in case CSS is overridden
  document.querySelectorAll('.js-pricing-v2').forEach(section => {
    const progressBar =
      section.querySelector('.js-stock-progress-bar') ||
      section.querySelector('.bg-yellow-400')
    if (progressBar) {
      const width =
        progressBar.getAttribute('data-width') ||
        progressBar.style.width ||
        '15%'
      progressBar.style.setProperty('width', width, 'important')
      progressBar.style.setProperty('background-color', '#facc15', 'important')
      progressBar.style.setProperty('height', '100%', 'important')
      // Ensure parent has height
      if (progressBar.parentElement) {
        progressBar.parentElement.style.setProperty(
          'height',
          '8px',
          'important'
        )
        progressBar.parentElement.style.setProperty(
          'background-color',
          'rgba(0,0,0,0.2)',
          'important'
        )
        progressBar.parentElement.style.setProperty(
          'border-radius',
          '9999px',
          'important'
        )
        progressBar.parentElement.style.setProperty(
          'overflow',
          'hidden',
          'important'
        )
      }
    }
  })

  // FAQ Toggle
  const faqItems = document.querySelectorAll('.js-faq-item')
  faqItems.forEach(item => {
    const trigger = item.querySelector('.js-faq-trigger')
    const content = item.querySelector('.js-faq-content')
    const icon = item.querySelector('.js-faq-icon')

    trigger.addEventListener('click', () => {
      const currentMaxHeight = content.style.getPropertyValue('max-height')
      const isOpen = currentMaxHeight && currentMaxHeight !== '0px'

      if (isOpen) {
        content.style.setProperty('max-height', '0px', 'important')
        content.style.setProperty('opacity', '0', 'important')
        content.style.setProperty('padding-bottom', '0px', 'important')
        if (icon) icon.style.transform = 'rotate(0deg)'
      } else {
        // Add extra buffer for padding (16px) to ensure content isn't clipped
        const totalHeight = content.scrollHeight + 20
        content.style.setProperty('max-height', totalHeight + 'px', 'important')
        content.style.setProperty('opacity', '1', 'important')
        content.style.setProperty('padding-bottom', '16px', 'important')
        if (icon) icon.style.transform = 'rotate(180deg)'
      }
    })
  })

  // Mobile Menu Drawer Toggle
  const mobileMenuBtns = document.querySelectorAll('.js-mobile-menu-btn')
  const mobileMenuBackdrops = document.querySelectorAll(
    '.js-mobile-menu-backdrop'
  )
  const mobileMenuDrawers = document.querySelectorAll('.js-mobile-menu-drawer')
  const mobileMenuCloses = document.querySelectorAll('.js-mobile-menu-close')
  const mobileMenuLinks = document.querySelectorAll('.js-mobile-menu-link')

  function openMobileMenu(index) {
    const backdrop = mobileMenuBackdrops[index]
    const drawer = mobileMenuDrawers[index]
    if (backdrop && drawer) {
      backdrop.classList.remove('opacity-0', 'pointer-events-none')
      backdrop.classList.add('opacity-100', 'pointer-events-auto')
      drawer.classList.remove('-translate-x-full')
      drawer.classList.add('translate-x-0')
    }
  }

  function closeMobileMenu(index) {
    const backdrop = mobileMenuBackdrops[index]
    const drawer = mobileMenuDrawers[index]
    if (backdrop && drawer) {
      backdrop.classList.remove('opacity-100', 'pointer-events-auto')
      backdrop.classList.add('opacity-0', 'pointer-events-none')
      drawer.classList.remove('translate-x-0')
      drawer.classList.add('-translate-x-full')
    }
  }

  mobileMenuBtns.forEach((btn, index) => {
    btn.addEventListener('click', () => openMobileMenu(index))
  })

  mobileMenuBackdrops.forEach((backdrop, index) => {
    backdrop.addEventListener('click', () => closeMobileMenu(index))
  })

  mobileMenuCloses.forEach((closeBtn, index) => {
    closeBtn.addEventListener('click', () => closeMobileMenu(index))
  })

  mobileMenuLinks.forEach(link => {
    link.addEventListener('click', () => {
      // Find the parent drawer index
      const container = link.closest('.js-mobile-menu-container')
      if (container) {
        const containers = Array.from(
          document.querySelectorAll('.js-mobile-menu-container')
        )
        const index = containers.indexOf(container)
        if (index !== -1) {
          closeMobileMenu(index)
        }
      }
    })
  })

  // Comparison Slider (Before/After)
  const sliders = document.querySelectorAll('.js-comparison-slider')
  sliders.forEach(slider => {
    const topImageDiv = slider.querySelector('.js-top-image')
    const topImg = topImageDiv ? topImageDiv.querySelector('img') : null
    const handle = slider.querySelector('.js-slider-handle')
    let isDown = false
    let isHover = false

    // Fix: Ensure the inner image width matches the container width to prevent resizing/distortion
    function syncImageWidth() {
      if (topImg) topImg.style.width = slider.offsetWidth + 'px'
    }
    syncImageWidth()
    window.addEventListener('resize', syncImageWidth)

    function updateSlider(x) {
      const rect = slider.getBoundingClientRect()
      let pos = ((x - rect.left) / rect.width) * 100
      if (pos < 0) pos = 0
      if (pos > 100) pos = 100
      if (topImageDiv) topImageDiv.style.width = pos + '%'
      if (handle) handle.style.left = pos + '%'
    }

    // Auto Animation Loop
    function animate() {
      if (!isDown && !isHover) {
        const time = Date.now()
        const newPos = 50 + 35 * Math.sin(time / 1500)
        if (topImageDiv) topImageDiv.style.width = newPos + '%'
        if (handle) handle.style.left = newPos + '%'
      }
      requestAnimationFrame(animate)
    }
    requestAnimationFrame(animate)

    // Drag Events
    slider.addEventListener('mousedown', () => (isDown = true))
    slider.addEventListener('touchstart', () => (isDown = true))
    window.addEventListener('mouseup', () => (isDown = false))
    window.addEventListener('touchend', () => (isDown = false))

    slider.addEventListener('mouseenter', () => (isHover = true))
    slider.addEventListener('mouseleave', () => {
      isHover = false
      isDown = false
    })

    slider.addEventListener('mousemove', e => {
      if (!isDown) return
      updateSlider(e.clientX)
    })
    slider.addEventListener('touchmove', e => {
      if (!isDown) return
      updateSlider(e.touches[0].clientX)
    })
  })

  // Carousel Scroll Buttons (for Comparison Carousel)
  document.querySelectorAll('.js-carousel-prev').forEach(btn => {
    btn.addEventListener('click', e => {
      const container = e.target
        .closest('.group')
        .querySelector('.js-carousel-container')
      if (container)
        container.scrollBy({ left: -container.clientWidth, behavior: 'smooth' })
    })
  })
  document.querySelectorAll('.js-carousel-next').forEach(btn => {
    btn.addEventListener('click', e => {
      const container = e.target
        .closest('.group')
        .querySelector('.js-carousel-container')
      if (container)
        container.scrollBy({ left: container.clientWidth, behavior: 'smooth' })
    })
  })

  // Auto Scroll & Drag (Selling Points V4 + Pricing Mobile Carousel)
  const dragCarousels = document.querySelectorAll(
    '.js-v4-carousel, .js-pricing-carousel'
  )
  dragCarousels.forEach(container => {
    let isDown = false
    let startX
    let scrollLeft

    // Mouse Drag (for Desktop view of mobile layout)
    container.addEventListener('mousedown', e => {
      isDown = true
      container.style.cursor = 'grabbing'
      startX = e.pageX - container.offsetLeft
      scrollLeft = container.scrollLeft
    })
    container.addEventListener('mouseleave', () => {
      isDown = false
      container.style.cursor = 'grab'
    })
    container.addEventListener('mouseup', () => {
      isDown = false
      container.style.cursor = 'grab'
    })
    container.addEventListener('mousemove', e => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - container.offsetLeft
      const walk = (x - startX) * 2
      container.scrollLeft = scrollLeft - walk
    })

    // Touch logic is native, but we need to track it to pause auto-scroll
    let isTouching = false
    container.addEventListener('touchstart', () => (isTouching = true), {
      passive: true,
    })
    container.addEventListener('touchend', () => (isTouching = false))

    // Auto scroll interval (Only for Selling Points V4, Pricing handles its own or manual)
    if (container.classList.contains('js-v4-carousel')) {
      setInterval(() => {
        // Only auto-scroll if it is in carousel mode (flex)
        if (isDown || isTouching) return
        if (container.scrollWidth <= container.clientWidth) return

        const itemWidth = container.clientWidth
        const totalItemWidth = itemWidth + 16 // gap-4 approx
        const currentScroll = container.scrollLeft
        const maxScroll = container.scrollWidth - container.clientWidth

        if (currentScroll >= maxScroll - 5) {
          container.scrollTo({ left: 0, behavior: 'smooth' })
        } else {
          const nextIndex = Math.floor(currentScroll / totalItemWidth) + 1
          const nextScroll = nextIndex * totalItemWidth
          container.scrollTo({
            left: Math.min(nextScroll, maxScroll),
            behavior: 'smooth',
          })
        }
      }, 4000)
    }
  })

  // Pricing Scroll Indicators
  const pricingCarousels = document.querySelectorAll('.js-pricing-carousel')
  pricingCarousels.forEach(container => {
    const section = container.closest('section')
    const indicatorsContainer = section
      ? section.querySelector('.js-pricing-indicators')
      : null
    if (!indicatorsContainer) return

    const dots = indicatorsContainer.querySelectorAll('.js-pricing-dot')

    const updateDots = () => {
      const scrollCenter = container.scrollLeft + container.clientWidth / 2
      let closest = 0
      let minDiff = Infinity

      // Assuming immediate children are the cards
      Array.from(container.children).forEach((child, index) => {
        const card = child
        const cardCenter = card.offsetLeft + card.offsetWidth / 2
        const diff = Math.abs(scrollCenter - cardCenter)
        if (diff < minDiff) {
          minDiff = diff
          closest = index
        }
      })

      dots.forEach((dot, idx) => {
        if (idx === closest) {
          dot.classList.remove('w-2', 'bg-gray-300')
          dot.classList.add('w-6', 'bg-gray-800')
        } else {
          dot.classList.add('w-2', 'bg-gray-300')
          dot.classList.remove('w-6', 'bg-gray-800')
        }
      })
    }

    container.addEventListener('scroll', updateDots)
    // Also update on mousemove/touchmove/up/down since we have drag logic
    container.addEventListener('mousemove', updateDots)
    container.addEventListener('touchmove', updateDots)
    container.addEventListener('touchend', updateDots)
  })

  // V4 Carousel Indicators
  const v4Carousels = document.querySelectorAll('.js-v4-carousel')
  v4Carousels.forEach(container => {
    const section = container.closest('section')
    const indicatorsContainer = section
      ? section.querySelector('.js-v4-indicators')
      : null
    if (!indicatorsContainer) return

    const dots = indicatorsContainer.querySelectorAll('.js-v4-dot')

    const updateDots = () => {
      // Calculate page index (each page is 100% width)
      const pageIndex = Math.round(container.scrollLeft / container.clientWidth)

      dots.forEach((dot, idx) => {
        if (idx === pageIndex) {
          dot.classList.remove('w-1.5', 'bg-gray-300')
          dot.classList.add('w-4', 'bg-gray-800')
        } else {
          dot.classList.add('w-1.5', 'bg-gray-300')
          dot.classList.remove('w-4', 'bg-gray-800')
        }
      })
    }

    container.addEventListener('scroll', updateDots)
    // Initial update
    updateDots()
  })

  // Comparison Carousel Logic (Indicators + Auto Loop + Drag)
  const comparisonCarousels = document.querySelectorAll(
    '.js-comparison-carousel'
  )
  comparisonCarousels.forEach(container => {
    const section = container.closest('section')
    const indicatorsContainer = section
      ? section.querySelector('.js-comparison-indicators')
      : null
    const dots = indicatorsContainer
      ? indicatorsContainer.querySelectorAll('.js-comparison-dot')
      : []

    let isDown = false
    let startX
    let scrollLeft

    // Drag Handlers
    container.addEventListener('mousedown', e => {
      isDown = true
      container.style.cursor = 'grabbing'
      startX = e.pageX - container.offsetLeft
      scrollLeft = container.scrollLeft
    })
    container.addEventListener('mouseleave', () => {
      isDown = false
      container.style.cursor = 'grab'
    })
    container.addEventListener('mouseup', () => {
      isDown = false
      container.style.cursor = 'grab'
    })
    container.addEventListener('mousemove', e => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - container.offsetLeft
      const walk = (x - startX) * 2
      container.scrollLeft = scrollLeft - walk
    })

    // Update Indicators & Logic
    const updateDots = () => {
      if (dots.length === 0) return

      // Find visible card
      const scrollCenter = container.scrollLeft + container.clientWidth / 2
      let closest = 0
      let minDiff = Infinity
      Array.from(container.children).forEach((child, index) => {
        const cardCenter = child.offsetLeft + child.offsetWidth / 2
        const diff = Math.abs(scrollCenter - cardCenter)
        if (diff < minDiff) {
          minDiff = diff
          closest = index
        }
      })

      dots.forEach((dot, idx) => {
        if (idx === closest) {
          dot.classList.remove('bg-gray-300', 'w-2')
          dot.classList.add('bg-gray-800', 'w-4')
        } else {
          dot.classList.add('bg-gray-300', 'w-2')
          dot.classList.remove('bg-gray-800', 'w-4')
        }
      })
    }
    container.addEventListener('scroll', updateDots)
    container.addEventListener('mousemove', updateDots) // Ensure updates during drag

    // Auto Loop for Carousel
    setInterval(() => {
      if (isDown || container.scrollWidth <= container.clientWidth) return

      // Assuming child items have equal width + gap.
      const firstChild = container.children[0]
      if (!firstChild) return
      const itemWidth = firstChild.offsetWidth + 16

      const maxScroll = container.scrollWidth - container.clientWidth

      if (container.scrollLeft >= maxScroll - 10) {
        container.scrollTo({ left: 0, behavior: 'smooth' })
      } else {
        const nextIndex = Math.round(container.scrollLeft / itemWidth) + 1
        const nextScroll = nextIndex * itemWidth
        container.scrollTo({ left: nextScroll, behavior: 'smooth' })
      }
    }, 4000)
  })

  // Feature Carousel Logic
  const featureCarousels = document.querySelectorAll('.js-feature-carousel')
  featureCarousels.forEach(container => {
    const track = container.querySelector('.js-feature-track')
    const prevBtn = container.querySelector('.js-feature-prev')
    const nextBtn = container.querySelector('.js-feature-next')
    const dotsContainer = container.nextElementSibling?.classList.contains(
      'js-feature-dots'
    )
      ? container.nextElementSibling
      : null
    const dots = dotsContainer
      ? dotsContainer.querySelectorAll('.js-feature-dot')
      : []

    let currentIndex = 0
    const items = track.children
    const totalItems = items.length

    if (totalItems <= 1) return

    const updateCarousel = () => {
      track.style.transform = 'translateX(-' + currentIndex * 100 + '%)'

      // Update dots
      dots.forEach((dot, idx) => {
        if (idx === currentIndex) {
          dot.classList.remove('bg-gray-300', 'hover:bg-gray-400')
          dot.classList.add('bg-gray-800')
        } else {
          dot.classList.add('bg-gray-300', 'hover:bg-gray-400')
          dot.classList.remove('bg-gray-800')
        }
      })
    }

    const nextSlide = () => {
      currentIndex = currentIndex === totalItems - 1 ? 0 : currentIndex + 1
      updateCarousel()
    }

    const prevSlide = () => {
      currentIndex = currentIndex === 0 ? totalItems - 1 : currentIndex - 1
      updateCarousel()
    }

    // Event Listeners
    if (nextBtn) nextBtn.addEventListener('click', nextSlide)
    if (prevBtn) prevBtn.addEventListener('click', prevSlide)

    dots.forEach((dot, idx) => {
      dot.addEventListener('click', () => {
        currentIndex = idx
        updateCarousel()
      })
    })

    // Auto Play
    let autoPlayInterval = setInterval(nextSlide, 5000)

    // Pause on hover
    container.addEventListener('mouseenter', () =>
      clearInterval(autoPlayInterval)
    )
    container.addEventListener(
      'mouseleave',
      () => (autoPlayInterval = setInterval(nextSlide, 5000))
    )

    // Touch Swipe Support
    let touchStartX = 0
    let touchEndX = 0

    container.addEventListener(
      'touchstart',
      e => {
        touchStartX = e.changedTouches[0].screenX
        clearInterval(autoPlayInterval) // Pause on touch
      },
      { passive: true }
    )

    container.addEventListener('touchend', e => {
      touchEndX = e.changedTouches[0].screenX
      handleSwipe()
      autoPlayInterval = setInterval(nextSlide, 5000) // Resume
    })

    const handleSwipe = () => {
      const threshold = 50 // Minimum distance for swipe
      if (touchEndX < touchStartX - threshold) {
        nextSlide() // Swipe Left -> Next
      }
      if (touchEndX > touchStartX + threshold) {
        prevSlide() // Swipe Right -> Prev
      }
    }
  })

  // Secondary Carousel Logic
  const secondarySections = document.querySelectorAll('.js-secondary-section')
  secondarySections.forEach(sectionEl => {
    const container = sectionEl.querySelector('.js-secondary-carousel')
    if (!container) return
    const track = sectionEl.querySelector('.js-secondary-track')
    const prevBtn = sectionEl.querySelector('.js-secondary-prev')
    const nextBtn = sectionEl.querySelector('.js-secondary-next')
    const dots = sectionEl.querySelectorAll('.js-secondary-dot')
    const itemsEle = sectionEl.querySelectorAll('.js-secondary-item')
    const overlayHits = sectionEl.querySelectorAll('.js-secondary-item-overlay')

    const totalPhysical = itemsEle.length
    const originLen = parseInt(container.getAttribute('data-item-count') || '1')
    if (totalPhysical === 0 || originLen === 0 || !track) return

    let currentIndex = originLen
    let isTransitioning = false
    let autoPlayInterval

    const updateCarousel = (enableTransition = true) => {
      if (enableTransition) {
        track.classList.add('transition-transform', 'duration-500', 'ease-out')
        itemsEle.forEach(el =>
          el.classList.add('transition-all', 'duration-500', 'ease-out')
        )
      } else {
        track.classList.remove(
          'transition-transform',
          'duration-500',
          'ease-out'
        )
        itemsEle.forEach(el =>
          el.classList.remove('transition-all', 'duration-500', 'ease-out')
        )
      }

      track.style.transform = `translateX(calc(50% - ${currentIndex} * calc(var(--card-width) + var(--card-gap)) - calc(var(--card-width) / 2)))`

      itemsEle.forEach((el, idx) => {
        const isActive = idx === currentIndex
        el.style.transform = isActive ? 'scale(1)' : 'scale(0.9)'
        el.style.opacity = isActive ? '1' : '0.6'

        const overlay = el.querySelector('.js-secondary-item-overlay')
        if (overlay) {
          if (isActive) {
            overlay.classList.add('hidden')
            overlay.classList.remove('block')
          } else {
            overlay.classList.remove('hidden')
            overlay.classList.add('block')
          }
        }
      })

      dots.forEach((dot, idx) => {
        if (idx === currentIndex % originLen) {
          dot.className =
            'js-secondary-dot h-2.5 rounded-full transition-all duration-300 w-8 bg-gray-800'
        } else {
          dot.className =
            'js-secondary-dot w-2.5 h-2.5 rounded-full transition-all duration-300 bg-gray-300 hover:bg-gray-400'
        }
      })
    }

    const nextSlide = () => {
      if (isTransitioning) return
      isTransitioning = true
      currentIndex++
      updateCarousel(true)
    }

    const prevSlide = () => {
      if (isTransitioning) return
      isTransitioning = true
      currentIndex--
      updateCarousel(true)
    }

    const slideToDot = idx => {
      const targetIdx = originLen + idx
      if (currentIndex === targetIdx || isTransitioning) return
      isTransitioning = true
      currentIndex = targetIdx
      updateCarousel(true)
    }

    track.addEventListener('transitionend', () => {
      isTransitioning = false
      if (currentIndex >= originLen * 2) {
        currentIndex -= originLen
        updateCarousel(false)
      } else if (currentIndex < originLen) {
        currentIndex += originLen
        updateCarousel(false)
      }
    })

    if (prevBtn)
      prevBtn.addEventListener('click', e => {
        e.preventDefault()
        prevSlide()
      })
    if (nextBtn)
      nextBtn.addEventListener('click', e => {
        e.preventDefault()
        nextSlide()
      })
    dots.forEach(dot => {
      dot.addEventListener('click', e => {
        e.preventDefault()
        slideToDot(parseInt(dot.getAttribute('data-real-idx') || '0'))
      })
    })
    overlayHits.forEach(overlay => {
      overlay.addEventListener('click', e => {
        e.preventDefault()
        slideToDot(parseInt(overlay.getAttribute('data-real-idx') || '0'))
      })
    })

    let touchStartX = 0
    let touchEndX = 0
    container.addEventListener(
      'touchstart',
      e => {
        touchStartX = e.changedTouches[0].screenX
        clearInterval(autoPlayInterval)
      },
      { passive: true }
    )
    container.addEventListener('touchend', e => {
      touchEndX = e.changedTouches[0].screenX
      if (touchStartX - touchEndX > 50) nextSlide()
      else if (touchEndX - touchStartX > 50) prevSlide()

      // Resume autoplay if no hover/touchstart
      autoPlayInterval = setInterval(nextSlide, 5000)
    })

    // Auto Play
    autoPlayInterval = setInterval(nextSlide, 5000)

    // Pause on hover
    container.addEventListener('mouseenter', () =>
      clearInterval(autoPlayInterval)
    )
    container.addEventListener(
      'mouseleave',
      () => (autoPlayInterval = setInterval(nextSlide, 5000))
    )

    setTimeout(() => {
      updateCarousel(false)
    }, 50)
  })

  // Infinite Scroll (Use Cases)
  const infiniteScrolls = document.querySelectorAll('.js-infinite-scroll')
  infiniteScrolls.forEach(container => {
    let isDown = false
    let startX
    let scrollLeft
    let animationId
    let isTouching = false

    // Track precise float position for smooth auto-scroll (Fix for iOS and consistent speed)
    let currentScrollPos = container.scrollLeft

    container.addEventListener('mousedown', e => {
      isDown = true
      container.style.cursor = 'grabbing'
      startX = e.pageX - container.offsetLeft
      scrollLeft = container.scrollLeft
      cancelAnimationFrame(animationId)
    })
    container.addEventListener('mouseleave', () => {
      isDown = false
      container.style.cursor = 'grab'
      // Sync position after interaction
      currentScrollPos = container.scrollLeft
      autoScroll()
    })
    container.addEventListener('mouseup', () => {
      isDown = false
      container.style.cursor = 'grab'
      currentScrollPos = container.scrollLeft
      autoScroll()
    })
    container.addEventListener('mousemove', e => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - container.offsetLeft
      const walk = (x - startX) * 2
      container.scrollLeft = scrollLeft - walk
    })

    // Touch Handlers for Mobile (Pause on touch)
    container.addEventListener(
      'touchstart',
      () => {
        isTouching = true
      },
      { passive: true }
    )
    container.addEventListener('touchend', () => {
      isTouching = false
      currentScrollPos = container.scrollLeft
    })

    // Auto scroll
    function autoScroll() {
      if (!isDown && !isTouching) {
        // Use smaller increment (0.4) to prevent "too fast" on high refresh screens
        // and use float variable to prevent iOS stalling due to rounding.
        currentScrollPos += 0.4

        if (currentScrollPos >= container.scrollWidth / 2) {
          currentScrollPos -= container.scrollWidth / 2
        }
        container.scrollLeft = currentScrollPos
        animationId = requestAnimationFrame(autoScroll)
      } else {
        // Keep loop alive but do nothing or just sync
        currentScrollPos = container.scrollLeft
        animationId = requestAnimationFrame(autoScroll)
      }
    }
    autoScroll()
  })

  // Pricing V2 Logic
  const pricingV2Sections = document.querySelectorAll('.js-pricing-v2')
  pricingV2Sections.forEach(pricingV2 => {
    // Countdown
    const hEl = pricingV2.querySelector('.js-timer-h')
    const mEl = pricingV2.querySelector('.js-timer-m')
    const sEl = pricingV2.querySelector('.js-timer-s')
    let timeLeft = 43749

    setInterval(() => {
      timeLeft = timeLeft > 0 ? timeLeft - 1 : 43749
      const h = Math.floor(timeLeft / 3600)
      const m = Math.floor((timeLeft % 3600) / 60)
      const s = timeLeft % 60
      if (hEl) hEl.textContent = String(h).padStart(2, '0')
      if (mEl) mEl.textContent = String(m).padStart(2, '0')
      if (sEl) sEl.textContent = String(s).padStart(2, '0')
    }, 1000)

    // Variants
    const variantImages = JSON.parse(
      pricingV2.getAttribute('data-variant-images') || '{}'
    )
    const variantBadges = JSON.parse(
      pricingV2.getAttribute('data-variant-badges') || '{}'
    )
    const mainImage = pricingV2.querySelector('.js-main-image')
    const shippingBadge = pricingV2.querySelector('.js-shipping-badge')

    const groups = pricingV2.querySelectorAll('.js-variant-group')

    function updateVariant() {
      // Ensure keys are sorted numerically to match generation logic
      const key = Object.keys(currentSelections)
        .sort((a, b) => Number(a) - Number(b))
        .map(k => currentSelections[k])
        .join('-')

      if (variantImages[key] && mainImage && currentSelections[2] <= 1) {
        mainImage.src = variantImages[key]
      }else if (currentSelections[2] > 1) {
        mainImage.src = getCur()?.featured_image?.src
      }

      if (shippingBadge) {
        // Default to true if undefined
        if (variantBadges[key] !== false) {
          shippingBadge.style.setProperty('display', 'flex', 'important')
        } else {
          shippingBadge.style.setProperty('display', 'none', 'important')
        }
      }
      changePrice()
    }

    groups.forEach((group, gIdx) => {
      const btns = group.querySelectorAll('.js-variant-btn')
      currentSelections[gIdx] = 0

      btns.forEach((btn, bIdx) => {
        btn.addEventListener('click', () => {
       
          btns.forEach(b => {
            b.classList.remove('border-black', 'bg-black', 'text-white')
            b.classList.add('border-gray-200', 'text-gray-600')
          })
          btn.classList.remove('border-gray-200', 'text-gray-600')
          btn.classList.add('border-black', 'bg-black', 'text-white')

          currentSelections[gIdx] = bIdx
          updateVariant()
        })
      })
    })

    // Initial update to ensure correct state on load
    updateVariant()
  })

  // Quantity Selector
  document.querySelectorAll('.js-pricing-quantity').forEach(qtyContainer => {
    const minusBtn = qtyContainer.querySelector('.js-btn-minus')
    const plusBtn = qtyContainer.querySelector('.js-btn-plus')
    const valEl = qtyContainer.querySelector('.js-quantity-value')
    let val = 1

    if (minusBtn && plusBtn && valEl) {
      minusBtn.addEventListener('click', e => {
        e.stopPropagation()
        if (val > 1) {
          val--
          valEl.textContent = val
          changePrice()
        }
      })
      plusBtn.addEventListener('click', e => {
        e.stopPropagation()
        val++
        valEl.textContent = val
        changePrice()
      })
    }
  })
})
